export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Szukaj',
  marketplaceDetailsCurtainCopyOptionTitle: 'Skopiuj link',
  marketplaceDetailsCurtainFlagOptionTitle: 'Zgłoś treść',
  marketplaceDetailsCurtainCopiedAlertText: 'Skopiowany link!',
  marketplaceDetailsFlagCurtainTitle: 'Zgłoś',
  marketplaceReportedCurtainContent: 'Zgłoszono treść',
  marketplaceAllItems: 'Wszystkie przedmioty',
  marketplaceWantToBuy: 'Chcę kupić {item} od {appname}'
}
